import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503adeb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-component" }
const _hoisted_2 = { class: "progress-container" }
const _hoisted_3 = { class: "progress-bar-overflow" }
const _hoisted_4 = { class: "progress-label" }

import { computed } from 'vue';
import Icon from './icon/Icon';
import IconComponent from './icon/IconComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressSemiCircle',
  props: {
    progress: null,
    maxPoints: null,
    icon: null,
    label: null
  },
  setup(__props: any) {

const props = __props as {
  progress: number;
  maxPoints: number;
  icon: Icon;
  label: string;
}



const barStyle = computed(() => {
  return {
    transform: `rotate(${
      45 + Math.min(props.progress / props.maxPoints, 1) * 100 * 1.8
    }deg)`
  };
});

// onmounted animate the progress bar

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "progress-bar",
          style: _normalizeStyle(_unref(barStyle))
        }, null, 4)
      ]),
      _createVNode(IconComponent, {
        icon: __props.icon,
        class: "progress-icon"
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1)
  ]))
}
}

})